const numberOfOptions = $(".option-selectors").data("options");

$(document).on("change", ".option-selectors select", function () {

  const optionOneValue = $("[data-name='Material']").find(":selected").text();

  if (numberOfOptions !== 2 || optionOneValue === "") {
    return;
  }

  $("[data-name='Size'] > option").each(function () {
    const optionTwoValue = this.value;
    const sizeOption = $("[data-name='Size']").data("index");
    const variantTitle = sizeOption === 'option2' ? optionOneValue + ' / ' + optionTwoValue : optionTwoValue + ' / ' + optionOneValue
    const element = $(".options--size").find(`[data-value='${optionTwoValue}']`);
    if (variantMap.includes(variantTitle)) {
      element.parent().show();
    } else {
      element.parent().hide();
    }

  });
});
$('.option-selectors .selector-wrapper:first-child select').trigger('change');

$(".options--material  a").on("click", function (event) {
  if (event.originalEvent === undefined) {
    return;
  }
  const id = $(this).parents("ul").attr("id");
  const selectorValue = id === "clickyboxes-SingleOptionSelector-1" ? 0 : 1;
  setTimeout(() => {
    $("#clickyboxes-SingleOptionSelector-" + selectorValue + " li:visible:first a").trigger('click');
  }, 100);
})

